// extracted by mini-css-extract-plugin
module.exports = {"root":"FlashMessage_root__19DAO","title":"FlashMessage_title__3ozMz","content":"FlashMessage_content__a_ury","icon":"FlashMessage_icon__3gefX","close":"FlashMessage_close__1L2Lg"};